import ViewStore from "./ViewStore";
import DaoLocator from "./factory/DaoLocator";
import { EventDispatcher } from "./event-dispatcher/EventDispatcher";
import ApiConnection, { createApiConnection } from "../infrastructure/api/ApiConnection";
import { AppConfig } from "./config";
import ApiClient from "../infrastructure/api/ApiClient";
import NotificationDispatcher from "./notification-dispatcher/NotificationDispatcher";
import ViewPropsFactory from "./factory/view-props/ViewPropsFactory";
import SessionStorage from "../infrastructure/storage/SessionStorage";
import PhotoUrlFactory from "../infrastructure/url-factory/PhotoUrlFactory";
import ActionsLocator from "./factory/ActionsLocator";
import LocalStorage from "../infrastructure/storage/LocalStorage";
import UserPreferencesStore from "./UserPreferencesStore";
import CookieStorage from "../infrastructure/storage/CookieStorage";
import OfferUrlFactory from "../infrastructure/url-factory/OfferUrlFactory";

export default class AppContainer {
    private instances: { [name: string]: object } = {};
    private readonly config: AppConfig;

    constructor(config: AppConfig) {
        this.config = config;
    }

    readonly getViewPropsFactory = (): ViewPropsFactory =>
        this.get('viewPropsFactory', () => new ViewPropsFactory(this));

    readonly getPhotoUrlFactory = (): PhotoUrlFactory =>
        this.get('PhotoUrlFactory', () => new PhotoUrlFactory(this.config.photosUrl))

    readonly getOfferUrlFactory = (): OfferUrlFactory =>
        this.get('OfferUrlFactory', () => new OfferUrlFactory(this.config.offerUrl))

    readonly getViewStore = (): ViewStore => this.get('store', () => new ViewStore(this.getLocalStorage()));

    readonly getDaosLocator = (): DaoLocator => this.get('daosLocator', () => new DaoLocator(this.getApiClient(), this.getLocalStorage()));

    readonly getEventDispatcher = (): EventDispatcher => this.get('eventDispatcher', () => new EventDispatcher());

    readonly getActionsLocator = (): ActionsLocator => this.get('actionsLocator', () => new ActionsLocator(this));

    readonly getApiClient = (): ApiClient =>
        this.get('apiClient', () => new ApiClient(this.getApiConnection(), this.getNotificationDispatcher()));

    readonly getApiConnection = (): ApiConnection => this.get('zrConnection', () => createApiConnection({
        baseUrl: this.config.apiUrl,
    }));

    readonly getNotificationDispatcher = (): NotificationDispatcher => this.get('notificationDispatcher', () => {
        return new NotificationDispatcher();
    });

    readonly getUserPreferencesStore = (): UserPreferencesStore =>
        this.get('userPreferencesStore', () => new UserPreferencesStore(this.getLocalStorage()));


    readonly getLocalStorage = (): LocalStorage => this.get('localStorage', () => new LocalStorage());

    protected readonly get = <T extends object>(name: string, factory: () => T): T => {
        if (!this.instances[name]) {
            this.instances[name] = factory();
        }
        return this.instances[name] as T;
    };
}
